import {
  SET_VOICE_QUEUES,
  SET_AGENTS_VOICE_QUEUE,
  SET_CAMPAIGNS_VOICE_AGENT,
  SET_AGENTS_VOICE_CAMPAIGN,
  SET_DIALOG_EXTEN,
  ADD_MESSAGE_ERROR_DIALING,
  ADD_MESSAGE_STATUS,
  ADD_CURRENT_PROTOCOL,
} from '@/store/mutation-types';

const mutations = {
  [SET_VOICE_QUEUES](state, queues) {
    state.queues = queues;
  },

  [ADD_MESSAGE_ERROR_DIALING](state, error) {
    state.errorCalling = error;
  },

  [SET_AGENTS_VOICE_QUEUE](state, agentsQueue) {
    state.agents = agentsQueue;
  },

  [SET_AGENTS_VOICE_CAMPAIGN](state, agentsAvailable) {
    state.agentsCampaign = agentsAvailable;
  },

  [SET_CAMPAIGNS_VOICE_AGENT](state, campaigns) {
    state.campaignsAgent = campaigns;
  },

  [SET_DIALOG_EXTEN](state, value) {
    state.dialogExten = value;
  },

  [ADD_MESSAGE_STATUS](state, value) {
    state.messageStatus = value;
  },

  [ADD_CURRENT_PROTOCOL](state, value) {
    state.activeJob = value;
  },

  RESET_VOICE_STATUS(state) {
    state.messageStatus = null;
  },
};

export default mutations;
